// Every report-param key the conjoint discrete block can persist, each set to null.

import { buildClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['cjc', 'cjd', 'cjt', 'cjv', 'cm', 'z', 's', 'cb', 'msp', 'msna']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  buildClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
